exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".isOnlyMatching[data-v-5abd233a]{display:inline-block;margin-top:4px;padding:3px 6px;color:#fff;font-size:10px;background:#f892aa;border-radius:5px}", ""]);

// exports
